export default "__VITE_ASSET__BuSdvmtn__"